<h1 mat-dialog-title class="text-center mb-0 fw-bold">Enter your discount code</h1>

<mat-divider></mat-divider>

<mat-dialog-content class="mt-1">
    <mat-form-field appearance="outline" class="w-100">
        <input [formControl]="discountCodeFormControl" required type="text" matInput required>
        <mat-label>Code</mat-label>
        <mat-hint>Enter your discount code</mat-hint>
        <mat-error>Field cannot be empty</mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-divider></mat-divider>
<div class="pt-2 pb-2">
    <mat-dialog-actions class="d-flex mt-1 justify-content-around" *ngIf="!isLoading">
        <button mat-dialog-close mat-raised-button class="w-25" color="warn">Close</button>
        <button mat-raised-button class="w-25" color="primary" [disabled]="!discountCodeFormControl.valid"
            (click)="redirectToDiscountedPaymentPlan()">Save</button>
    </mat-dialog-actions>
    <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
</div>